import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Masonry from "react-masonry-css"; // Importer Masonry
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

const metaByCategory = {
  2: {
    title: "PAINTING | ELIZE SOKOLOVA",
    //description: "Découvrez nos œuvres d'illustration artistiques et uniques.",
  },
  3: {
    title: "MURAL | ELIZE SOKOLOVA",
  },
  4: {
    title: "CERAMIC | ELIZE SOKOLOVA",
  },
  5: {
    title: "PHOTO | ELIZE SOKOLOVA",
  },
  6: {
    title: "VIDEO | ELIZE SOKOLOVA",
  },
  "5-1": {
    title: "PLASTORIA | ELIZE SOKOLOVA",
  },
  "5-2": {
    title: "GLACE JEWELRY | ELIZE SOKOLOVA",
  },
  "5-3": {
    title: "Z OO M | ELIZE SOKOLOVA",
  },
  "5-4": {
    title: "LA BOUCLE —O— | ELIZE SOKOLOVA",
  },
  "5-7": {
    title: "LA VAGUE — | ELIZE SOKOLOVA",
  },
  "5-8": {
    title: "BERLIN COLOR | ELIZE SOKOLOVA",
  },
  "5-9": {
    title: "BLACKORWHITE | ELIZE SOKOLOVA",
  },
  "5-10": {
    title: "BODY SHAPES/ | ELIZE SOKOLOVA",
  },
  "5-11": {
    title: "ULTRA VIOLET | ELIZE SOKOLOVA",
  },
  "5-12": {
    title: "ECUADOR AVENTURA | ELIZE SOKOLOVA",
  },
  "5-15": {
    title: "JUNGLA | ELIZE SOKOLOVA",
  },
  "5-13": {
    title: "SIERRA | ELIZE SOKOLOVA",
  },
  "5-14": {
    title: "COSTA | ELIZE SOKOLOVA",
  },
};

const Categories = () => {
  const { catId, subCatId } = useParams(); // Récupère le categoryId depuis l'URL
  const [gridsData, setGridsData] = useState(null);
  const [contentData, setContentData] = useState({});
  const [error, setError] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const location = useLocation();

  // CHARGEMENT DES GRILLES
  useEffect(() => {
    // Vérification si sous catégorie ou catégorie
    let endpoint = subCatId ? "idsscat" : "idcat";
    let endpointId = subCatId ? subCatId : catId;

    // Fonction pour récupérer les grilles
    const fetchGrids = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}fetch_grids.php?${endpoint}=${endpointId}`,
        );
        if (!response.ok) {
          throw new Error(
            "Erreur lors du chargement des grilles de la catégorie",
          );
        }
        const data = await response.json();
        setGridsData(data);
      } catch (err) {
        setError(err.message);
      }
    };

    // Charger les grilles
    fetchGrids();
  }, [catId, subCatId]);

  // CHARGEMENT DU CONTENU
  useEffect(() => {
    if (gridsData && Array.isArray(gridsData) && gridsData.length > 0) {
      // Fonction pour récupérer le contenu de chaque grille
      const fetchContent = async (gridId) => {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}fetch_content.php?id=${gridId}`,
          );
          if (!response.ok) {
            throw new Error(
              "Erreur lors du chargement du contenu de la grille",
            );
          }
          const data = await response.json();
          // Stocker le contenu de chaque grille en fonction de son ID
          setContentData((prev) => ({
            ...prev,
            [gridId]: data,
          }));
        } catch (err) {
          setError(err.message);
        }
      };

      // Parcourir chaque grille et récupérer son contenu
      gridsData.forEach((grid) => {
        fetchContent(grid.id);
      });
    }
  }, [gridsData]);

  // Décoder le code HTML
  function decodeHtmlEntities(text) {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
  }

  // Décoder les sauts à la ligne
  function renderTextWithLineBreaks(text) {
    if (!text) return null;
    const decodedText = decodeHtmlEntities(text);
    return decodedText.split("\n").map((line, index) => (
      <span key={index}>
        {line}
        <br />
      </span>
    ));
  }

  // Affectation des titres
  let metaKey = subCatId ? `${catId}-${subCatId}` : catId;
  let meta = metaByCategory[metaKey] || {
    title: "Galerie | ELIZE SOKOLOVA",
    //description: ".",
  };

  return (
    <div>
      <Navigation />
      <Helmet>
        <title>{meta.title}</title>
        {/* <meta name="description" content={meta.description} /> */}
        <link
          rel="canonical"
          href={`https://www.elizesokolova.com${location.pathname}`}
        />
      </Helmet>
      <div className="wrapper">
        {/* Affichage des erreurs */}
        {error && <div>Erreur : {error}</div>}

        {/* Affichage si aucune grille disponible */}
        {gridsData && Array.isArray(gridsData) && gridsData.length === 0 && (
          <div style={{ textAlign: "center" }}>
            Aucune donnée disponible pour cette catégorie.
          </div>
        )}

        {/* Affichage des grilles */}
        {gridsData && Array.isArray(gridsData) && gridsData.length > 0 && (
          <div className="pubPages-grid-container">
            {gridsData.map((grid) => (
              <div
                key={grid.id}
                className={"pubPages-grid"}
                style={{ width: grid.size + "%" }}
              >
                {/* Affichage du contenu de la grille */}
                {contentData[grid.id] && contentData[grid.id].length > 0 ? (
                  Number(grid.isFlex) ? (
                    <Masonry
                      breakpointCols={{
                        default: Number(grid.nbrFlex) || 3,
                        /*2180: 2,*/
                        1200: 1,
                      }}
                      className="my-masonry-grid"
                      columnClassName="my-masonry-grid_column"
                      style={{
                        "--masonry-gap": `${grid.gapFlex}px`,
                        "--masonry-gap-neg": `-${grid.gapFlex}px`,
                      }}
                    >
                      {contentData[grid.id].map((content, index) => {
                        switch (content.type) {
                          case "text":
                            return (
                              <div key={index}>
                                {renderTextWithLineBreaks(content.text)}
                              </div>
                            );

                          case "image":
                            return content.link === 0 ? (
                              <div
                                key={index}
                                className="pubPages-content"
                                style={{ marginBottom: `${grid.bottomFlex}px` }}
                              >
                                <img
                                  src={content.media_url}
                                  alt={decodeHtmlEntities(content.media_title)}
                                  onClick={() =>
                                    setSelectedImage(content.media_url)
                                  }
                                />
                                <div className="pubPages-contentMedia-title">
                                  {decodeHtmlEntities(content.media_title)}
                                </div>
                                <div className="pubPages-contentMedia-desc">
                                  {renderTextWithLineBreaks(content.media_desc)}
                                </div>
                              </div>
                            ) : (
                              <NavLink
                                to={`/${content.link_url}`}
                                key={index}
                                className="pubPages-content"
                                style={{
                                  marginBottom: `${grid.bottomFlex}px`,
                                  display: "block",
                                }}
                              >
                                <img
                                  src={content.media_url}
                                  alt={decodeHtmlEntities(content.media_title)}
                                />
                                <div
                                  className={
                                    content.showLink
                                      ? "pubPages-content-showlink"
                                      : "pubPages-content-linked"
                                  }
                                >
                                  {content.media_title}
                                </div>
                              </NavLink>
                            );

                          case "video":
                            return (
                              <div
                                key={index}
                                className="pubPages-content"
                                style={{ marginBottom: `${grid.bottomFlex}px` }}
                              >
                                <div className="pubPages-contentVideo-title">
                                  {decodeHtmlEntities(content.media_title)}
                                </div>
                                <div className="pubPages-contentVideo-desc">
                                  {renderTextWithLineBreaks(content.media_desc)}
                                </div>
                                <video
                                  controls
                                  src={content.media_url}
                                  controlsList="nodownload"
                                  autoPlay
                                  muted
                                  loop
                                  playsInline
                                  webkit-playsinline="true"
                                />
                              </div>
                            );

                          case "title":
                            return (
                              <div
                                key={index}
                                className="pubPages-content-title"
                              >
                                <div className="pubPages-contentTitle">
                                  {decodeHtmlEntities(content.title)}
                                </div>
                                <div className="pubPages-contentTitle-desc">
                                  {renderTextWithLineBreaks(content.title_desc)}
                                </div>
                              </div>
                            );

                          default:
                            return null;
                        }
                      })}
                    </Masonry>
                  ) : (
                    <div style={{ width: "100%" }}>
                      {contentData[grid.id].map((content, index) => {
                        switch (content.type) {
                          case "text":
                            return (
                              <div key={index}>
                                {renderTextWithLineBreaks(content.text)}
                              </div>
                            );

                          case "image":
                            return content.link === 0 ? (
                              <div
                                key={index}
                                className="pubPages-content"
                                style={{ marginBottom: `${grid.bottomFlex}px` }}
                                onClick={() =>
                                  setSelectedImage(content.media_url)
                                }
                              >
                                <img
                                  src={content.media_url}
                                  alt={decodeHtmlEntities(content.media_title)}
                                />
                                <div className="pubPages-contentMedia-title">
                                  {decodeHtmlEntities(content.media_title)}
                                </div>
                                <div className="pubPages-contentMedia-desc">
                                  {renderTextWithLineBreaks(content.media_desc)}
                                </div>
                              </div>
                            ) : (
                              <NavLink
                                to={`/${content.link_url}`}
                                key={index}
                                className="pubPages-content"
                                style={{
                                  marginBottom: `${grid.bottomFlex}px`,
                                  display: "block",
                                }}
                              >
                                <img
                                  src={content.media_url}
                                  alt={decodeHtmlEntities(content.media_title)}
                                />
                                <div className="pubPages-content-linked">
                                  {content.media_title}
                                </div>
                              </NavLink>
                            );

                          case "video":
                            return (
                              <div key={index} className="pubPages-content">
                                <div className="pubPages-contentVideo-title">
                                  {decodeHtmlEntities(content.media_title)}
                                </div>
                                <div className="pubPages-contentVideo-desc">
                                  {renderTextWithLineBreaks(content.media_desc)}
                                </div>
                                <video
                                  controls
                                  src={content.media_url}
                                  controlsList="nodownload"
                                  autoPlay
                                  loop
                                  muted
                                  playsInline
                                  webkit-playsinline="true"
                                />
                              </div>
                            );

                          case "title":
                            return (
                              <div
                                key={index}
                                className="pubPages-content-title"
                              >
                                <div className="pubPages-contentTitle">
                                  {decodeHtmlEntities(content.title)}
                                </div>
                                <div className="pubPages-contentTitle-desc">
                                  {renderTextWithLineBreaks(content.title_desc)}
                                </div>
                              </div>
                            );

                          default:
                            return null;
                        }
                      })}
                    </div>
                  )
                ) : (
                  <div>{/* Aucun contenu */}</div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <span className="close" onClick={() => setSelectedImage(null)}>
            &times;
          </span>
          <img src={selectedImage} alt="" />
        </div>
      )}
    </div>
  );
};

export default Categories;
